module.exports = __webpack_public_path__ + "img/ic-popup-service-fee.6c2cb30b.png";